module.exports = __webpack_public_path__ + "img/mrj.b7e32f2a.svg";